import { ref, onBeforeUnmount } from 'vue'

// Pure helpers usable from non-component code (services) — safe guards for SSR/tests
export function lockBody() {
  try {
    if (typeof document === 'undefined' || !document.body || !document.body.style) return null
    const prev = document.body.style.overflow
    try {
      document.body.style.overflow = 'hidden'
    } catch {
      /* noop */
    }
    return prev
  } catch {
    return null
  }
}

export function unlockBody(prevOverflow) {
  try {
    if (typeof document === 'undefined' || !document.body || !document.body.style) return
    try {
      document.body.style.overflow = prevOverflow || ''
    } catch {
      /* noop */
    }
  } catch {
    /* noop */
  }
}

export function useModalBodyLock() {
  const originalOverflow = ref(null)
  const isLocked = ref(false)

  function lock() {
    try {
      if (!isLocked.value) {
        originalOverflow.value = lockBody()
        isLocked.value = true
      }
    } catch {
      /* noop */
    }
  }

  function unlock() {
    try {
      if (isLocked.value) {
        unlockBody(originalOverflow.value)
        isLocked.value = false
      }
    } catch {
      /* noop */
    }
  }

  onBeforeUnmount(() => {
    unlock()
  })

  return { lock, unlock, isLocked }
}
